const REQUIRED = "Поле обязательно для заполнения";

export const required = (value: string) => {
  if (!value) {
    return REQUIRED;
  }

  return undefined;
};
